<template>
  <van-notice-bar
    left-icon=""
    :scrollable="false"
    class="faq-notice"
    :class="{ zhanwei: faqNotice.length === 0 }"
  >
    <van-swipe
      vertical
      class="faq-notice-swipe"
      :autoplay="3000"
      :show-indicators="false"
      @change="onChange"
      v-if="faqNotice.length > 0"
    >
      <van-swipe-item
        v-for="item in faqNotice"
        :key="item.ID"
        class="van-ellipsis"
        >{{ item.TITLE }}</van-swipe-item
      >
    </van-swipe>
    <van-button
      class="faq-notice-btn"
      round
      block
      type="info"
      @click="goDetail"
    >
      {{ languages.smartOrderLook }}
    </van-button>
  </van-notice-bar>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { clickButton } from '@plugins/biPoint/_configOfficialSupport';
export default {
  props: {
    source: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nowActiveIndex: 0
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.mywork,
      faqSiteName: state => state.faqSiteName,
      faqNotice: state => state.faqNotice
    })
  },
  async created() {
    if (this.faqNotice.length === 0) {
      this.getFaqNotice();
    }
  },
  methods: {
    ...mapActions(['getFaqNotice']),
    onChange(index) {
      this.nowActiveIndex = index;
    },
    goDetail() {
      clickButton({
        btnName: 'clickFaqNotice',
        locationKey: this.source || '',
        otherParams: {
          faqId: this.faqNotice[this.nowActiveIndex].ID
        }
      });
      if (this.$route.name === 'workfaqdetail') {
        this.$router.replace({
          name: 'workfaqdetail',
          query: {
            faqId: this.faqNotice[this.nowActiveIndex].ID
          }
        });
      } else {
        this.$router.push({
          name: 'workfaqdetail',
          query: {
            faqId: this.faqNotice[this.nowActiveIndex].ID
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.faq {
  &-notice {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    padding: 0;
    margin: 18px auto;
    border-radius: 8px;
    background-color: var(--block-bg-light-color);
    &.zhanwei {
      margin: -10px auto 0;
      background-color: transparent;
    }
    ::v-deep .van-notice-bar__content {
      width: 100%;
    }
    &-swipe {
      width: 290px;
      height: 40px;
      line-height: 40px;
      color: var(--text-color);
      padding-left: 10px;
    }
    &-btn {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      width: 81px;
      height: 22px;
      border-radius: 26px;
      font-size: 12px;
      background: var(--main-color);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 2px 22px;
    }
  }
}
</style>
